export enum ROUTE_ADDIN {
  HOME = 'addin',
}
